import React, { useContext } from 'react';

import { DataContext } from '../../stores/crm-person-store';
import { DataContext as SharedDataContext } from '../../stores/crm-store';
import { HandleAddPerson } from './requests/PersonRequests';

import GenericFormModal from './shared/GenericFormModal';
import EditText from './shared/field_inputs/text/EditText';
import EditItem from './shared/field_inputs/item/EditItem';
import EditSelectSearchable from "./shared/field_inputs/select/EditSelectSearchable";
import { createGetSuggestionsFromApiUrl } from './shared/field_inputs/HelpMethods';
import { CalculateSettings } from './shared/Functions';

// This method solves the problem of inserting the row at the right index. It has been replaced with
// prependInTable. It is kept temporaroly in case this functionality is requested from customer.
// const __ARCHIVED__insertIntoTable = (person, store, dispatch) => {
//     // ! This method adds to the store without regarding filters.
//     // For example. Apply name filter "Adam", add "Kent" and "Kent" could still be added to the window.
//     // This is due to unfinished filter structure.
//     const storeIsEmpty = !store.rows?.length;
//     const areAllRowsInWindow = store.fetchSettings.maxIndex && store.fetchSettings.maxIndex === store.rows.length;
//     const firstRow = store.rows[0];
//     const lastRow = store.rows[store.rows.length - 1];
//     const isBeforeFirst = store.rows?.length && firstRow?.name >= person.name;
//     const isAfterLast = store.rows?.length && lastRow?.name <= person.name;

//     if (!areAllRowsInWindow && (isBeforeFirst || isAfterLast)) {
//         return;
//     }
//     if (storeIsEmpty) {
//         store.rows = []; // Make it's not undefined
//     }

//     store.rows.push(person);
//     store.rows.sort((a, b) => {
//         var nameA = a.name.toUpperCase(); // ignore upper and lowercase
//         var nameB = b.name.toUpperCase(); // ignore upper and lowercase
//         if (nameA < nameB) {
//             return -1;
//         }
//         if (nameA > nameB) {
//             return 1;
//         }
//         return 0;
//     });
//     if (!areAllRowsInWindow) store.rows.pop();

//     store.fetchSettings.maxIndex += 1;
//     store.settings = CalculateSettings(store.fetchSettings);
//     dispatch({ type: 'UPDATE_DATA', payload: store.rows });
//     dispatch({ type: 'UPDATE_FETCH_SETTINGS_AND_SETTINGS', fetchSettings: store.fetchSettings, settings: store.settings });
// };

const prependInTable = (person, store, dispatch) => {
    store.rows.splice(0, 0, person);
    store.requestObject.amount += 1;
    store.viewSettings = CalculateSettings(store.viewSettings, store.requestObject);
    dispatch({ type: 'UPDATE_DATA', payload: store.rows });
    dispatch({ type: 'UPDATE_VIEW_SETTINGS_AND_REQUEST_OBJECT', viewSettings: store.viewSettings, requestObject: store.requestObject });
};

const AddPerson = () => {
    const { dispatch, store } = useContext(DataContext);
    const {
        store: { RoleOptions },
    } = useContext(SharedDataContext);

    const formComponents = [
        {
            propName: 'name',
            label: 'Namn',
            validate: (v) => (!v || !v.length ? 'Fyll i namn.' : ''),
            component: <EditText autoFocus />,
        },
        {
            propName: 'organization',
            label: 'Organisation',
            validate: (v) => (!v ? 'Fyll i företag.' : ''),
            component: (
                <EditItem
                    iconName='organization'
                    isClearable
                    isCreationPermitted
                    getSuggestions={createGetSuggestionsFromApiUrl('/api/crmOrganizationFront/getOrganizationSuggestions')}
                />
            ),
        },
        {
            propName: 'phone',
            label: 'Telefon',
            component: <EditText />,
        },
        {
            propName: 'email',
            label: 'Email',
            component: <EditText />,
        },
        {
            propName: 'role',
            label: 'Roll',
            component: <EditSelectSearchable {...{ iconName: 'role', options: RoleOptions }} />,
        },
        {
            propName: 'roleOther',
            label: 'Roll övrigt',
            component: <EditText />,
        },
    ];

    const handleAdd = async (person) => {
        const response = await HandleAddPerson(person);
        if (response.success) {
            prependInTable(response.data, store, dispatch);
        }
        return response;
    };

    return <GenericFormModal label='+ Person' description='Lägg till ny Person' formComponents={formComponents} handleAdd={handleAdd} />;
};

export default AddPerson;
